import ApiService from './api.service'

const PlanService = {

  /***
   * Query plans
   * @returns {*}
   */
  query (payload) {
    return ApiService.post('plan/query', payload)
  },
}
export default PlanService
